"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WIDTH_BREAKPOINTS = [275, 400, 500, 608, 700, 980];
exports.default = (function (itemWidth) {
    return exports.WIDTH_BREAKPOINTS.filter(function (breakpoint) { return breakpoint <= itemWidth; })
        .map(function (value) { return value + "px"; })
        .join(' ');
});
//# sourceMappingURL=get-thumbnail-min-width-attribute.js.map